<template>
  <v-row>
    <v-col cols="12" sm="12">
      <v-card class="chart-container" :loading="isLoading">
        <div class="pa-4"> 
        <h2 class="title">{{graphTitle}}</h2>
        <v-divider class="pb-4"/>
        <line-chart class="chart" v-if="chartDataSettings.graphType == 'line' && !isLoading"
          :measurement="chartDataSettings.measurement"
          :showInLabel="showInLabel"
          :chartData="chartData"></line-chart>
        <bar-chart class="chart" v-if="chartDataSettings.graphType == 'bar' && !isLoading" 
          :measurement="chartDataSettings.measurement"
          :showInLabel="showInLabel"
          :chartData="chartData"></bar-chart>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
.chart-container{
  height:700px;
  width:100%;
}
.chart{
  padding-top: 1em;
  height:600px;
  width:100%;
}
</style>
<script>
import { mapState } from 'vuex'
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'
import api from '@/api'

export default {
  components: {
    LineChart,
    BarChart
  },
  data () { return {
    chartData: {},
    datasets: {},
    graphTitle: 'Loading...',
    isLoading: true,
    query: {},
    groupBy: null
  }},
  computed: {
    ...mapState(['chartDataSettings']),
    showInLabel: function () { 
      if (this.chartDataSettings.dataResolution.value == '1_MONTH') return 'month'
      if (this.chartDataSettings.dataResolution.value == '1d') return 'day' 
      return 'hours'
    }
  },
  watch: {
    chartDataSettings: {
      handler: function (query) { 
        this.graphType = query.graphType
        this.groupBy = query.groupBy
        this.query = query
        this.loadData()
      },
      deep: true
    }
  },
  created: function (){
    this.query = this.chartDataSettings
    this.loadData()
  },
  methods: {
    async loadData() {
      try{
        if (this.query.nets.length < 1) { return }
        this.isLoading = true
        this.graphTitle = 'Loading ...'
        let minmaxdata = false
        let timeSeries = await api.sensorsData(this.query)
        if (this.chartDataSettings.showMinMax) {
          minmaxdata = await api.sensorsMinMaxData(this.query)
        }  
        this.datasets = this.fillData(timeSeries, minmaxdata)
        this.chartData = { datasets: this.datasets }
        if (this.groupBy) this.groupData(this.groupBy)
      } catch (error) {
        console.log('loadData ', error)
      }
    },
    groupData(groupByKey) {
      let seriesObjectGrouped = this.datasets.reduce((r, v, i, a, k = v[groupByKey] ) => ((r[k] || (r[k] = [])).push(v.data), r), {})
      let labels = Object.keys(seriesObjectGrouped)
      let colors = ['#003f5c','#665191','#a05195','#d45087','#f95d6a','#ff7c43','#ffa600',"#688dcd", "#66b046", "#8463cc", "#a6953f", "#c361aa", "#55a47b", "#cc566a", "#cd6c39"]
      let seriesData = Object.values(seriesObjectGrouped)
      seriesData = seriesData.map(serie => serie[0].map((col, i) => serie.map(row => row[i]))) //transpose
      seriesData = seriesData.map((serie) => serie.map((station) => {
        const data = station.filter(s => s != undefined).reduce(
          ({yValueSum, counter, xValue}, point) => ({
            counter: (point && point.y != null) ? counter + 1 : counter,
            yValueSum: (point && point.y != null) ? point.y + yValueSum : yValueSum,
            xValue: (point && point.x != null && xValue ==null) ? point.x : xValue })
          , {yValueSum: null, counter: null, xValue: null})
        return data.counter ? { y: data.yValueSum / data.counter, x: data.xValue } : { y: null, x: data.xValue }
      }))
      seriesData = seriesData.map((serie, index) => ({
        data: serie,
        label: labels[index],
        fill: false,
        backgroundColor: colors[index],
        borderColor: colors[index],
      }))
      this.chartData = { datasets: seriesData }
    },
    fillData (timeSeries, minmaxdata) {
      let datasets = []
      for (let i = 0; i < timeSeries.length; i++){
        let series = timeSeries[i].data.map(({ time, value }) => ({x:time, y : value }))
        if (this.showInLabel != 'hours') series.pop() // remove last data with only timezone shift values
        datasets.push({
          label: timeSeries[i].sensor.name,
          region: timeSeries[i].sensor.region,
          area: timeSeries[i].sensor.area,
          data: series,
          year: timeSeries[i].year,
          fill: false,
          backgroundColor: timeSeries[i].sensor.color,
          borderColor: timeSeries[i].sensor.color,
        })
      }
      if(minmaxdata) {
        let min = minmaxdata.min.map(({ time, value }) => ({x: new Date(time).getTime(), y : value }))
        let max = minmaxdata.max.map(({ time, value }) => ({x: new Date(time).getTime(), y : value }))
        datasets.push({
          radius: 0,
          label: 'Max',
          data: max,
          fill: false,
          fillOpacity: '.7', 
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          borderColor: "rgba(0, 0, 0, 0)"
        })
        datasets.push({
          radius: 0,
          label: 'Min',
          data: min,
          fill: '-1',
          fillOpacity: '.7', 
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          borderColor: "rgba(0, 0, 0, 0)"
        })
      }
      this.isLoading = false
      this.graphTitle = (this.chartDataSettings.measurement == 'temperature' ? 'Average Temperatures' : 'Accumulated Precipitations') + ' - Resolution of  ' + this.chartDataSettings.dataResolution.text
      return datasets 
    },
  }
}
</script>
